import {createBrowserHistory} from 'history';

/**
 * Single shared history instance used by the router and navigation middleware.
 *
 * @returns Shared browser history instance.
 */
export const history = createBrowserHistory();
